// extracted by mini-css-extract-plugin
export default {"wrapper":"TextLabelValue_wrapper__ddu4W","label":"TextLabelValue_label__N5mlf","value":"TextLabelValue_value__3gwK1","secondary":"TextLabelValue_secondary__IOzsF"};